/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import FooterMenuItem from "@qlik/qlik/src/components/Footer/FooterMenuItem";
import isNoItem from "@qlik/qlik/src/lib/util/isNoItem";
import { useI18n } from "@qlik/utils/i18nContext";

/**
 * FooterMainMenu component
 * This component renders the main menu in the footer.
 * Each menu item is rendered with a FooterMenuItem component.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.horizontalMenu - The horizontal menu to be rendered.
 * @param {Object} props.verticalMenu - The vertical menu to be rendered.
 *
 * @returns {React.Element} The rendered FooterMainMenu component.
 */
const FooterMainMenu = ({ verticalMenu }) => {
    // State to keep track of the currently expanded menu item
    const [expandedMenuId, setExpandedMenuId] = useState();
    const { i18n } = useI18n();

    const columnSlice = (array) => {
        let chunks = [];
        if (i18n.curr.langCode === "en" && array.length > 5) {
            chunks = [array.slice(0, 2), array.slice(2, 4), [array[4]], ...columnSlice(array.slice(5))];
        } else if (array.length > 5) {
            chunks = [array.slice(0, 2), array.slice(2, 3), array.slice(3, 5), ...columnSlice(array.slice(5))];
        } else if (array.length > 3) {
            chunks = [array.slice(0, 1), array.slice(1, 2), array.slice(2, 3), ...columnSlice(array.slice(3))];
        } else {
            chunks.push(array);
        }
        return chunks;
    };

    const menuItemsChunks = columnSlice(verticalMenu?.menuItems.filter((menuItem) => !isNoItem(menuItem?.title)) || []);

    return (
        <div className="flex max-lg:flex-col max-lg:gap-10 lg:gap-25 xl:gap-33.75">
            {/* Render each chunk of items in the vertical menu */}
            {menuItemsChunks?.map((chunk, i) => (
                <ul key={i} className="gap-10 max-lg:flex max-lg:flex-col">
                    {chunk.map((menuItem) => (
                        <FooterMenuItem
                            expanded={expandedMenuId === menuItem.id}
                            setExpandedMenuId={setExpandedMenuId}
                            key={`${menuItem.id}`}
                            menuItem={menuItem}
                            type="vertical"
                        />
                    ))}
                </ul>
            ))}
        </div>
    );
};

export default FooterMainMenu;
